import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../../app/root-route.js";
import { GuestApp } from "./GuestApp.js";

export const guestGalleryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/g/$slug/gallery",
  validateSearch: (s: Record<string, unknown>): { t?: string } => ({
    t: typeof s.t === "string" ? s.t : undefined,
  }),
  component: () => {
    const { slug } = guestGalleryRoute.useParams();
    const { t } = guestGalleryRoute.useSearch();
    return <GuestApp slug={slug} t={t} defaultTab="gallery" />;
  },
});
